module.exports = __webpack_public_path__ + "static/media/blanket-state-3.ad38ca0e.wav";